import { render, staticRenderFns } from "./squadTable.vue?vue&type=template&id=761a48f8"
import script from "./squadTable.vue?vue&type=script&lang=js"
export * from "./squadTable.vue?vue&type=script&lang=js"
import style0 from "./squadTable.vue?vue&type=style&index=0&id=761a48f8&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports